module.exports = __webpack_public_path__ + "static/media/personal_logo.fae7a54c.png";